module.exports = "/next-static/_next/static/images/block_image_easy-ee1ca4e94c47f23a529000f6b019c501.png";